/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/function-component-definition */
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';
import mediaURL from '../../../../util/mediaURL';
import Icon from '../Icon';

const propTypes = exact({
  handleOptionClick: PropTypes.func.isRequired,
  option: PropTypes.shape({
    text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    icon: PropTypes.shape({
      url: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    }),
    options: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        icon: PropTypes.shape({
          url: PropTypes.string.isRequired,
          alt: PropTypes.string.isRequired,
        }),
      })
    ),
  }).isRequired,
  selectedValues: PropTypes.array,
  selected: PropTypes.bool,
  setSelectedOption: PropTypes.func,
  showIcon: PropTypes.bool,
});

const defaultProps = {
  selected: false,
  showIcon: false,
  selectedValues: [],
  setSelectedOption: () => {},
};

const DropdownItem = ({
  handleOptionClick,
  option,
  selectedValues,
  selected,
  setSelectedOption,
  showIcon,
}) => {
  const hasMoreOptions = option.options && option.options.length;

  return (
    <li key={option.value} className="DropdownMultiple_item">
      <div className="DropdownMultiple_subItem">
        <button
          type="button"
          className={`DropdownMultiple_itemButton ${
            selected ? 'DropdownMultiple_itemButton-active' : ''
          }`}
          onClick={() =>
            hasMoreOptions ? setSelectedOption(option.value) : handleOptionClick(option.value)
          }
        >
          {showIcon && option.icon && (
            <img
              className="DropdownMultiple_itemButtonIcon"
              src={mediaURL(option.icon.url)}
              alt={option.icon.alt}
            />
          )}
          {option.text}
          {hasMoreOptions && !!option.options.find((x) => selectedValues.includes(x.value)) && (
            <span className="DropdownMultiple_itemButtonMarker" />
          )}
        </button>
        {!hasMoreOptions && selectedValues.includes(option.value) && (
          <Icon id="tick" blockName="DropdownMultiple_itemIcon" />
        )}
        {hasMoreOptions && <Icon id="arrow-right" blockName="DropdownMultiple_itemIcon" />}
      </div>
      {hasMoreOptions && (
        <ul
          className={`DropdownMultiple_list DropdownMultiple_list-subItems ${
            selected ? 'DropdownMultiple_list-subItemsActive' : ''
          }`}
        >
          <li className="DropdownMultiple_item DropdownMultiple_subItem">
            <Icon id="arrow-left" blockName="DropdownMultiple_itemIcon" />
            <div
              className="DropdownMultiple_itemButton"
              onClick={() => setSelectedOption(option.value)}
            >
              {option.text}
            </div>
          </li>
          {option.options.map((subOption) => (
            <li key={subOption.value} className="DropdownMultiple_item">
              <div className="DropdownMultiple_subItem">
                <button
                  type="button"
                  className="DropdownMultiple_itemButton"
                  onClick={() => handleOptionClick(subOption.value)}
                >
                  {subOption.text}
                </button>
                {selectedValues.includes(subOption.value) && (
                  <Icon id="tick" blockName="DropdownMultiple_itemIcon" />
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

DropdownItem.propTypes = propTypes;
DropdownItem.defaultProps = defaultProps;

export default DropdownItem;
